import { render, staticRenderFns } from "./InputPriceMarket.vue?vue&type=template&id=4543f76b&"
import script from "./InputPriceMarket.vue?vue&type=script&lang=js&"
export * from "./InputPriceMarket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCol,VRow,VSelect})


/* hot reload */
if (module.hot) {
  var api = require("/builds/saas-tool/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4543f76b')) {
      api.createRecord('4543f76b', component.options)
    } else {
      api.reload('4543f76b', component.options)
    }
    module.hot.accept("./InputPriceMarket.vue?vue&type=template&id=4543f76b&", function () {
      api.rerender('4543f76b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/InputPriceMarket.vue"
export default component.exports